
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
function SideEdit() {
  const { id } = useParams()
  const { user, isAuth } = useContext(AuthContext)
  return (
    <div className="offcanvas-body p-0">
      {/* Card START */}
      <div className="card w-100">
        {/* Card body START */}
        <div className="card-body">
          {/* Side Nav START */}
          <ul className="nav nav-tabs nav-pills nav-pills-soft flex-column fw-bold gap-2 border-0">
            
            <li className="nav-item" >
              <a className="nav-link d-flex mb-0 active"  href={"/myprofil/" + id}> <img className="me-2 h-20px fa-fw" src="../assets/images/icon/person-outline-filled.svg" alt /><span>Account </span></a>
            </li>
          </ul>
          {/* Side Nav END */}
        </div>
        {/* Card body END */}
        {/* Card footer */}
        <div className="card-footer text-center py-2">
 
        </div>


      </div>
 
    </div>
  )
}

export default SideEdit